<template lang="pug">
  div(v-cloak)
    v-card(raised hover)
      v-card-title.primary
        span 見積 # {{index+1}}
        v-spacer
        v-chip.my-0(small disabled outline color="white")
          v-avatar
            v-icon fa-cube
          span {{box.token}}
        v-tooltip(bottom)
          v-icon.grey--text.text--lighten-1(slot="activator") shuffle
          span マウスで明細の順番を入れ替えることができます。

      v-card-text
        v-layout(row wrap)
          v-flex(xs12)
            .app-line
              span.app-line-title 商品名
              span.app-line-text {{box.input.overview.item_name}}
              span.app-line-suffix
            .app-line
              span.app-line-title 備考
              span.app-line-text {{box.input.overview.description}}
              span.app-line-suffix
            .app-line
              span.app-line-title 注釈
              span.app-line-text {{box.input.overview.comment}}
              span.app-line-suffix
          v-flex(xs6)
              img(:src="box.image" width="100%")
          v-flex(xs6)
            .app-line
              span.app-line-title 個数
              span.app-line-text {{box.input.overview.quantity|number}}
              span.app-line-suffix 個
            .app-line
              span.app-line-title 重量
              span.app-line-text {{box.weight.total|number(2)}}
              span.app-line-suffix kg
            .app-line
              span.app-line-title 価格
              span.app-line-text {{box_total|number}}
              span.app-line-suffix 円
            .app-line
              span.app-line-title 別枠追加明細
              span.app-line-text {{box.input.appendices.length|number}}
              span.app-line-suffix 件

            v-dialog.d-block(v-model="detailDialog" fullscreen persistent transition="dialog-bottom-transition")
              v-btn.mt-4.mb-0(block small color="primary" slot="activator")
                v-icon search
                span 明細を開く
              v-toolbar.primary(dense)
                v-spacer
                v-btn(small icon @click.stop="detailDialog = false")
                  v-icon close
              v-card(tile)
                order-box(:index="index")
        v-btn(flat small color="primary" @click="editInput", :disabled="!progressing")
          v-icon edit
          span 編集
        v-btn(flat small color="primary" @click="copyInput", :disabled="!progressing")
          v-icon content_copy
          span 同じ設定を入力に転記
        v-btn(flat small color="warning" @click="abandonBox(index)", :disabled="!progressing")
          v-icon close
          span 破棄

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import OrderBox from './Box'
import _ from 'underscore'
import mathjs from 'mathjs'

export default {
  props: ['index'],
  components: {
    OrderBox
  },
  data () {
    return {
      box: null,
      detailDialog: false
    }
  },
  created () {
    this.box = this.getBox(this.index)
  },
  computed: {
    ...mapGetters('app/order', ['getBox', 'progressing']),
    box_total () {
      let self = this
      let total = self.box.summary.fixed_amount
      _.each(self.box.input.appendices, function (appendix) {
        total = mathjs.ceil(mathjs.add(total, appendix.amount))
      })
      return total
    }
  },
  methods: {
    ...mapActions('app/order', ['activateTab', 'removeBox', 'replaceInput', 'reEdit']),
    abandonBox (index) {
      this.removeBox(index)
    },
    copyInput () {
      this.replaceInput(this.box.input)
      this.activateTab('input')
    },
    editInput () {
      this.reEdit({input: this.box.input, token: this.box.token})
      this.activateTab('input')
    }
  }
}
</script>

<style scoped lang="stylus">
</style>



// WEBPACK FOOTER //
// src/app/pages/Order/Components/ListItem.vue